import { FC, ReactNode, useMemo } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { cx } from "shared/utils";
import { SubscriptionStatuses } from "../types";

type Props = {
  status: SubscriptionStatuses;
  size?: BadgeSize;
  className?: string;
};

export const SubscriptionStatusBadge: FC<Props> = ({
  status,
  size = BadgeSize.SM,
  className
}) => {
  const {
    variant,
    icon,
    title
  }: {
    variant: BadgeVariant;
    icon?: ReactNode;
    title?: string;
  } = useMemo(() => {
    switch (status) {
      case SubscriptionStatuses.ACTIVE:
        return {
          variant: BadgeVariant.SUCCESS,
          title: "Active"
        };
      case SubscriptionStatuses.EXPIRED:
        return {
          variant: BadgeVariant.ERROR,
          title: "Expired"
        };
      case SubscriptionStatuses.INACTIVE:
        return {
          variant: BadgeVariant.BASE,
          title: "Inactive"
        };
      default:
        return { variant: BadgeVariant.BASE, title: status };
    }
  }, [status]);

  return (
    <Badge
      className={cx("shrink-0 items-center", className)}
      size={size}
      variant={variant}
      leftElement={icon}
    >
      {title}
    </Badge>
  );
};
